<template>



    <el-card shadow="never" @click.native="verCapa(card.capa)" class="card-header" :body-style="{ padding: '0px' }">
        <el-button type="primary" circle="" size="default" class="btn-back-mb" icon="el-icon-back"
            @click="verCapa(card.capa)"></el-button>

        <img :src="card.capa.imagen_url" class="image">
        <div class="card-content">
            <div class="text-content">
                <div class="nombre" ref="observedElement">{{ card.capa.nombre }}


                </div>

                <div class="direccion">{{ card.capa.nombre_direccion }}
                    <!-- <table class="table-datos-capa">
                                        <tr>
                                            <td>Eje Prioritario</td>
                                            <th>{{ card.capa.eje_prioritario }}</th>

                                        </tr>
                                        <tr>
                                            <td>Horas cátedras</td>
                                            <th>{{ card.capa.horas_catedra }}</th>

                                        </tr>
                                    </table> -->
                    <span>Eje Prioritario <strong>{{ card.capa.eje_prioritario
                            }}</strong></span><span>Horas
                        cátedras
                        <strong>{{card.capa.horas_catedra}}</strong> </span>

                </div>
                <div class="modalidad">{{ card.capa.modalidad }}
                </div>

               
            </div>
            <div class="boton">


            </div>
        </div>
    </el-card>




</template>

<script>
import { EventBus } from '@/event-bus'
export default {
    name: 'CustomCard',
    props: {
        card: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            observer: null,
        }
    },
    mounted() {
        this.createObserver();
    },
    methods: {
        createObserver() {
            // Crear un nuevo IntersectionObserver
            this.observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (!entry.isIntersecting) {
                        EventBus.$emit('mostrarNombreHeader', this.card.capa.nombre)
                        // // El elemento ha dejado de ser visible
                        // console.log("El elemento ha dejado de ser visible");
                        // this.handleElementInvisible();
                    } else {
                        // El elemento está visible
                        EventBus.$emit('mostrarNombreHeader', false)
                    }
                });
            });

            // Comenzar a observar el elemento
            this.observer.observe(this.$refs.observedElement);
        },
        handleElementInvisible() {
            // Acción que quieres ejecutar cuando el elemento deja de ser visible
            alert("El elemento ya no es visible en la pantalla");
        },
        getTextoBoton(capa) {
            return capa.hasActiveComision ? 'Inscripciones disponibles' : 'Próximamente'
        },
        verCapa(capa) {
            let origen = this.$route.query.origen; // Obtenemos el parámetro 'origen' de la query string

            if (origen) {
                // Si el origen es 'docente', usamos history.back()
                this.$router.push({ name: 'homeDocente' });
                return; // Salimos de la función para evitar la ejecución posterior
            }

            switch (this.$route.name) {
                case 'detalleCapa':
                    this.$router.push({ name: 'home' });
                    break;
                case 'detalleCom':
                    this.$router.push({ name: 'detalleCapa', params: { token: capa.token, nombre: capa.slug } });
                    break;
                default:
                    break;
            }
        }
      

    },
    beforeDestroy() {
        // Dejar de observar el elemento cuando el componente se destruya
        if (this.observer) {
            this.observer.disconnect();
        }
    },
}
</script>

<style scoped>
.sticky-nombre {
    position: -webkit-sticky;
    /* Safari */
    position: sticky;
    top: 80px;
    z-index: 1000;
    /* Asegúrate de que quede sobre otros elementos */
    background-color: white;
    /* Fondo blanco para que resalte */
    padding: 10px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    /* Sombra opcional para darle énfasis */
}
.table-datos-capa {
  
    width: 100%;
    border-collapse: collapse;
    /* border-radius: 8px; */
    margin-bottom: 0px;

}

.table-datos-capa tr>td,
.table-datos-capa tr>th {
    border: none;
    padding: 2px;
    text-align: left;
    font-size: 14px;
    color:#174263;
    /* border-top: 1px solid #ccc; */

}
.card-header {
    /* border: 1px solid #ccc; */
    border-radius: 0px;
    /* overflow: hidden; */
    /* box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); */
    font-family: 'Roboto', sans-serif;
    /* display: flex; */
    /* Cambio clave: Flexbox para la tarjeta */
    flex-direction: column;
    /* Cambio clave: Dirección de columna */
    display: flex;
    flex-direction: column;
    height: 100%;
    /* Nuevo: Asegurar altura completa */
    cursor: pointer;
    transition: all 0.2s;
    margin-top: 0;
    overflow: visible;


}



.image {
    width: 100%;
    height: auto;
}

.card-content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 16px;
    flex-grow: 1;
    
    transition: all 0.2s;
}

.text-content {
    flex-grow: 1;
}

.nombre {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 8px;
}
.nombre small{
    display: block;
}

.direccion {
    font-size: 14px;
    color: #03A9F4;
    margin-bottom: 8px;
}
.direccion span{
    
    margin-top: 2px;
    display: block;
    margin-left: 1px;
    color: #174263;
}

.direccion span > strong {
  padding:2px;
   background: #f1f1f1;
}

.modalidad {
    display: inline-block;
    background-color: #17a2b8;
    color: #fff;
    padding: 6px 12px;
    border-radius: 2px;
    margin-bottom: 5px;
    margin-right: 5px;
    font-size: 14px;
}

.comisiones-a {
    display: inline-block;
    background-color: #47aa05;
    color: #fff;
    padding: 6px 12px;
    border-radius: 2px;
    margin-bottom: 16px;
    margin-left: 0px;
    font-size: 14px;
}

.comisiones-c {
    display: inline-block;
    background-color: #FFC107;
    color: #fff;
    padding: 6px 12px;
    border-radius: 2px;
    margin-bottom: 16px;
    margin-left: 0px;
    font-size: 14px;
}

.btn-back-mb{
    position: absolute;
    top:10px;
    left:20px;
}
.boton {
    position: relative;
    width: 100%;
    /* Cambio clave: Ancho completo para el botón */
    margin-top: auto;
    /* Cambio clave: Empujar el botón hacia abajo */
    border-radius: 0;
    /* Opcional: Eliminar bordes redondeados del botón */
    /* height: 100px; */
}

/* .el-button {
    position: absolute;
    width: 100%;
    top: -50px;
    font-family: 'Roboto', sans-serif;
    background: #174263 url(@/assets/base2.png) !important;
   
}

.el-button--danger {
    text-transform: uppercase;
    background: #800322ce url(@/assets/base2.png) !important;
    border-color: #800322ce !important;
} */
</style>
